import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { WarningDialogData } from '../../model/query-interface';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-warning-dialog',
  imports: [MatDialogModule, TranslateModule, MatButtonModule],
  templateUrl: './warning-dialog.component.html',
  styleUrl: './warning-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningDialogComponent {
  constructor(
    public _dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: WarningDialogData,
  ) {}

  /**
   * Closes the dialog and returns true to indicate confirmation.
   *
   * @memberof WarningDialogComponent
   */
  public confirmClick() {
    this._dialogRef.close(true);
  }

  /**
   * Closes the dialog and returns false to indicate cancellation.
   *
   * @memberof WarningDialogComponent
   */
  public cancelClick() {
    this._dialogRef.close(false);
  }
}
